import {debugLog} from "../Utils/LogUtils";
import {useEffect} from 'react';
import {
    isBeneficiaryInsuranceAllowed,
    isCompletionInsuranceAllowed,
    isCriticalIllnessInsuranceAllowed
} from "../Utils/PlanUtils";

// If the user selects a plan that does not allow for a certain type of insurance, we need to reset the insurance option
export default function useUpdateInsuranceOptions(state) {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!isCriticalIllnessInsuranceAllowed(state) && state.plan.criticalIllnessInsurance) {
            state.setPlan(prevData => ({...prevData, criticalIllnessInsurance: false}));
        }
        if (!isBeneficiaryInsuranceAllowed(state) && state.plan.nomineeInsurance) {
            state.setPlan(prevData => ({...prevData, nomineeInsurance: false}));
        }
        if (!isCompletionInsuranceAllowed(state) && state.plan.completionInsurance) {
            state.setPlan(prevData => ({...prevData, completionInsurance: false}));
        }

        debugLog("useUpdateInsuranceOptions 1");
    }, [state.plan.planTypeID, state.plan.depositMode, state.subscriber.birthdate]);

    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (isCompletionInsuranceAllowed(state) && !state.plan.completionInsurance) {
            state.setPlan(prevData => ({...prevData, completionInsurance: true}));
        }
        debugLog("useUpdateInsuranceOptions 2");
    }, [state.plan.planTypeID, state.plan.depositMode, state.subscriber.birthdate]);


    //Plan 2 insurances are set to match Plan 1 insurances
    useEffect(() => {
        //If the second plan is in T mode, we don't want to change the completion insurance
        if (state.plan2.depositMode === 'T') {
            return;
        }
        if (state.plan2.criticalIllnessInsurance !== state.plan.criticalIllnessInsurance) {
            state.setPlan2(prevData => ({...prevData, criticalIllnessInsurance: state.plan.criticalIllnessInsurance}));
        }
    }, [state.plan.criticalIllnessInsurance]);

    /*
    useEffect(() => {
        if (state.plan2.nomineeInsurance !== state.plan.nomineeInsurance) {
            state.setPlan2(prevData => ({...prevData, nomineeInsurance: state.plan.nomineeInsurance}));
        }
    }, [state.plan.nomineeInsurance]);
     */



    //Plan 2 completionInsurance set to match Plan 1 insurance as long as plan 2 is not a T mode
    useEffect(() => {
        //If the second plan is in T mode, we don't want to change the completion insurance
        if (state.plan2.depositMode === 'T') {
            return;
        }
        if (state.plan2.completionInsurance !== state.plan.completionInsurance) {
            state.setPlan2(prevData => ({...prevData, completionInsurance: state.plan.completionInsurance}));
        }

        //Make sure to turn CI insurance off if it is not allowed (I.e. because completion insurance is not also turned on)
        if (!isCriticalIllnessInsuranceAllowed(state) && state.plan.criticalIllnessInsurance) {
            state.setPlan(prevData => ({...prevData, criticalIllnessInsurance: false}));
        }
    }, [state.plan.completionInsurance]);

    // When the second plan Mode changes to T, turn off all insurance
    // If it's not a T mode, set the insurances to match the first plan
    useEffect(() => {
        if (state.plan2.depositMode === 'T') {
            state.setPlan2(prevData => ({
                ...prevData,
                completionInsurance: false,
                criticalIllnessInsurance: false,
            }));
        } else {
            state.setPlan2(prevData => ({
                ...prevData,
                completionInsurance: state.plan.completionInsurance,
                criticalIllnessInsurance: state.plan.criticalIllnessInsurance,
            }));
        }
    }, [state.plan2.depositMode]);
}